module.exports = __webpack_public_path__ + "img/language.768c3bc5.svg";